export const q = (pattern) => document.querySelector(pattern);
export const qs = (pattern) => Array.from(document.querySelectorAll(pattern));
export const qe = (pattern, index) => qs(pattern).length > 0 ? qs(pattern)[index] : null;
export const find = (ele, pattern) => ele ? ele.querySelector(pattern) : null;
export const findAll = (ele, pattern) => ele ? Array.from(ele.querySelectorAll(pattern)) : [];
export const qv = (pattern) => {
    const qs1 = qe(pattern, 0);
    if (qs1?.nodeValue) {
        return qs1?.nodeValue ?? "";
    }
    else {
        return qs1?.value ?? "";
    }
};
export const dc = (tag) => document.createElement(tag);
export const dcs = (tag, count) => {
    const returnValue = [];
    for (let i = 0; i < count; i++) {
        returnValue.push(dc(tag));
    }
    return returnValue;
};
export const Trim = (val) => val ? val.trim() : "";
